/* Coffee for Humans — live Phase 1.5 fixes.
   Scoped to CFH pages. No external calls. */
(function () {
  'use strict';

  var CFH = {
    personas: {
      human: { name: 'The Human', coffee: 'Colombia • Medium', url: '/products/the-human', color: '#e4dfb5', text: '#492506', tagline: 'Smooth, low-acid, hard to mess up.', reasons: ['Best first bag if you want the safe-good choice.', 'Balanced cocoa, walnut, and red apple without drama.', 'Works in drip, French press, pour-over, or however morning happens.'] },
      mastermind: { name: 'The Mastermind', coffee: 'Ethiopia • Light-Medium', url: '/products/the-mastermind', color: '#e4dfb5', text: '#492506', tagline: 'Bright, layered, built for slow thinking.', reasons: ['Best for humans who like clarity and detail.', 'Brighter profile without turning coffee into homework.', 'Good fit for pour-over, AeroPress, and slow mornings.'] },
      nightowl: { name: 'The Night Owl', coffee: 'Central/South America • Dark', url: '/products/the-night-owl', color: '#e4dfb5', text: '#492506', tagline: 'Dark, bold, useful after everyone else quits.', reasons: ['Best for strong cups and late-start humans.', 'Lower-drama dark roast profile with real weight.', 'Works well when milk, ice, or chaos enters the room.'] },
      champion: { name: 'The Champion', coffee: 'Colombia • Medium-Dark Decaf', url: '/products/the-champion', color: '#e4dfb5', text: '#492506', tagline: 'Steady flavor without the caffeine tax.', reasons: ['Best when you want the ritual without the caffeine bill.', 'Medium-dark comfort without decaf punishment.', 'Good for evening cups, reset days, and steady routines.'] },
      barista: { name: 'The Barista', coffee: 'Colombia & Ethiopia • Medium-Dark', url: '/products/the-barista', color: '#e4dfb5', text: '#492506', tagline: 'Craft-forward without needing a café setup.', reasons: ['Best for humans who enjoy dialing in a cup.', 'Blend depth for espresso-style drinks and intentional brews.', 'More craft than default coffee, less fragile than precious coffee.'] },
      adventurer: { name: 'The Adventurer', coffee: 'Nicaragua • Medium', url: '/products/the-adventurer', color: '#e4dfb5', text: '#492506', tagline: 'Big enough for a detour. Easy enough for daily use.', reasons: ['Best when dependable coffee feels too obvious.', 'Medium roast with enough character to notice.', 'Flexible for changing mornings and mixed brew methods.'] },
      creative: { name: 'The Creative', coffee: 'Nicaragua & Ethiopia • Light-Medium', url: '/products/the-creative', color: '#e4dfb5', text: '#492506', tagline: 'Unexpected flavor without making coffee weird.', reasons: ['Best for humans who want personality in the cup.', 'Light-medium blend with a more expressive edge.', 'Interesting enough for play, practical enough for daily use.'] },
      nonhuman: { name: 'The Non-Human', coffee: 'Rotating Origins • Varies', url: '/products/the-non-human', color: '#e4dfb5', text: '#492506', tagline: 'For humans who refuse the obvious answer.', reasons: ['Best for the least predictable human in the room.', 'Rotating profile keeps repeat orders from going stale.', 'Pick this when “normal coffee” sounds like a warning.'] }
    },
    order: ['human', 'mastermind', 'nightowl', 'champion', 'barista', 'adventurer', 'creative', 'nonhuman'],
    questions: [
      {
        q: 'First: what do you actually want from coffee?',
        answers: [
          ['Something smooth and reliable every morning', { human: 2, champion: 1 }],
          ['Something bright enough to make me pay attention', { mastermind: 2, barista: 1 }],
          ['Something bold that can keep up', { nightowl: 2, adventurer: 1 }],
          ['Something surprising — I hate boring coffee', { creative: 2, nonhuman: 1 }]
        ]
      },
      {
        q: 'How forgiving does your coffee need to be?',
        answers: [
          ['Very. I am not measuring grams before 8 a.m.', { human: 2, champion: 1 }],
          ['Somewhat. I like a good cup without a science project', { adventurer: 2, creative: 1 }],
          ['Not much. I enjoy dialing it in', { barista: 2, mastermind: 1 }],
          ['I make chaos work', { nonhuman: 2, nightowl: 1 }]
        ]
      },
      {
        q: 'Pick the flavor lane you trust most.',
        answers: [
          ['Chocolate, nuts, round and balanced', { human: 2, champion: 1 }],
          ['Fruit, florals, clean acidity', { mastermind: 2, barista: 1 }],
          ['Dark, heavy, low-drama', { nightowl: 2 }],
          ['Depends on the day — surprise me', { creative: 2, nonhuman: 1, adventurer: 1 }]
        ]
      },
      {
        q: 'What does your morning usually look like?',
        answers: [
          ['Routine, practical, get moving', { human: 2, champion: 1 }],
          ['Quiet focus before everyone needs something', { mastermind: 2, barista: 1 }],
          ['Late start, strong cup, no apologies', { nightowl: 2, nonhuman: 1 }],
          ['Different every day', { adventurer: 2, creative: 1 }]
        ]
      },
      {
        q: 'How do you usually brew?',
        answers: [
          ['Drip machine or whatever is easiest', { human: 2, champion: 1 }],
          ['Pour-over, AeroPress, or another ritual', { barista: 2, mastermind: 1 }],
          ['French press, espresso, or strong cold brew', { nightowl: 2, creative: 1 }],
          ['Hotel room, campsite, office — wherever', { adventurer: 2, nonhuman: 1 }]
        ]
      },
      {
        q: 'Final answer: what kind of human are you today?',
        answers: [
          ['Grounded. I want the dependable good thing', { human: 3 }],
          ['Precise. I want the interesting good thing', { mastermind: 3, barista: 1 }],
          ['Driven. I want fuel that does not get in my way', { champion: 2, nightowl: 1 }],
          ['Unpredictable. I want coffee with a little personality', { creative: 2, adventurer: 1, nonhuman: 1 }]
        ]
      }
    ]
  };

  function isFindMyCoffeePage() {
    return /\/pages\/find-my-coffee\/?$/.test(window.location.pathname);
  }

  function scoreWinner(scores) {
    var best = CFH.order[0];
    var bestScore = -1;
    CFH.order.forEach(function (key) {
      if ((scores[key] || 0) > bestScore) {
        best = key;
        bestScore = scores[key] || 0;
      }
    });
    return best;
  }

  function track(name, payload) {
    if (typeof window.cfhTrack === 'function') window.cfhTrack(name, payload || {});
  }

  function buildQuiz(root) {
    var state = { index: 0, scores: {} };
    CFH.order.forEach(function (key) { state.scores[key] = 0; });

    function renderIntro() {
      root.innerHTML = '' +
        '<section class="cfh-live-quiz cfh-live-quiz--intro" aria-labelledby="cfh-live-quiz-title">' +
          '<p class="cfh-live-quiz__eyebrow">Coffee For Humans</p>' +
          '<h1 id="cfh-live-quiz-title">What Kind of Human Are You?</h1>' +
          '<p>Six practical questions. One coffee that fits how you actually drink it.</p>' +
          '<button type="button" class="cfh-live-quiz__primary" data-cfh-start>Start Quiz →</button>' +
          '<small>Takes about 2 minutes</small>' +
        '</section>';
      root.querySelector('[data-cfh-start]').addEventListener('click', renderQuestion);
      track('cfh_quiz_intro_rendered', { source: 'find_my_coffee' });
    }

    function renderQuestion() {
      var question = CFH.questions[state.index];
      var pct = Math.round((state.index / CFH.questions.length) * 100);
      root.innerHTML = '' +
        '<section class="cfh-live-quiz cfh-live-quiz--question" aria-labelledby="cfh-live-question">' +
          '<div class="cfh-live-quiz__progress"><span>Question ' + (state.index + 1) + ' of ' + CFH.questions.length + '</span><span>' + pct + '%</span></div>' +
          '<div class="cfh-live-quiz__track"><span style="width:' + pct + '%"></span></div>' +
          '<h2 id="cfh-live-question">' + question.q + '</h2>' +
          '<div class="cfh-live-quiz__answers"></div>' +
        '</section>';
      var answers = root.querySelector('.cfh-live-quiz__answers');
      question.answers.forEach(function (answer) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cfh-live-quiz__answer';
        btn.textContent = answer[0];
        btn.addEventListener('click', function () {
          Object.keys(answer[1]).forEach(function (key) {
            state.scores[key] = (state.scores[key] || 0) + answer[1][key];
          });
          state.index += 1;
          if (state.index < CFH.questions.length) renderQuestion();
          else renderResult();
        });
        answers.appendChild(btn);
      });
      track('cfh_quiz_question_view', { question_index: state.index + 1, question_total: CFH.questions.length });
    }

    function renderResult() {
      var key = scoreWinner(state.scores);
      var persona = CFH.personas[key];
      var reasons = persona.reasons.map(function (reason) { return '<li>' + reason + '</li>'; }).join('');
      root.innerHTML = '' +
        '<section class="cfh-live-quiz cfh-live-quiz--result" aria-labelledby="cfh-live-result">' +
          '<p class="cfh-live-quiz__eyebrow">Your Coffee Match</p>' +
          '<h1 id="cfh-live-result">You are ' + persona.name + '</h1>' +
          '<p>' + persona.tagline + '</p>' +
          '<p class="cfh-live-quiz__coffee">' + persona.coffee + '</p>' +
          '<ul class="cfh-live-quiz__reasons" role="list">' + reasons + '</ul>' +
          '<div class="cfh-live-quiz__actions">' +
            '<a class="cfh-live-quiz__primary" href="' + persona.url + '">Shop ' + persona.name + ' →</a>' +
            '<button type="button" class="cfh-live-quiz__secondary" data-cfh-open-popup>Email me my match + 10% off</button>' +
            '<a class="cfh-live-quiz__secondary" href="/collections/all">Compare all coffees</a>' +
            '<button type="button" class="cfh-live-quiz__secondary" data-cfh-retake>Retake Quiz</button>' +
          '</div>' +
        '</section>';
      root.querySelector('[data-cfh-retake]').addEventListener('click', function () {
        state.index = 0;
        CFH.order.forEach(function (personaKey) { state.scores[personaKey] = 0; });
        renderIntro();
      });
      track('cfh_quiz_complete', { matched_product_handle: persona.url.replace('/products/', '') });
      track('cfh_quiz_result_view', { result_key: key, product_handle: persona.url.replace('/products/', '') });
    }

    renderIntro();
  }

  function patchFindMyCoffeePage() {
    if (!isFindMyCoffeePage()) return;
    document.documentElement.classList.add('cfh-find-my-coffee-page');
    if (document.body) document.body.classList.add('cfh-find-my-coffee-page');
    Array.prototype.slice.call(document.querySelectorAll('main p')).forEach(function (node) {
      if ((node.textContent || '').trim() === 'Find My Coffee') {
        node.classList.add('cfh-live-page-heading');
        if (node.parentElement) node.parentElement.classList.add('cfh-live-page-heading-wrap');
      }
    });
    var oldQuiz = document.querySelector('.cfh-quiz-wrap, #cfh-quiz');
    if (!oldQuiz || oldQuiz.dataset.cfhLivePatched === 'true') return;
    oldQuiz.dataset.cfhLivePatched = 'true';
    if (oldQuiz.parentElement) oldQuiz.parentElement.classList.add('cfh-live-quiz-shell');
    buildQuiz(oldQuiz);
  }

  function run() {
    patchFindMyCoffeePage();
    window.setTimeout(patchFindMyCoffeePage, 250);
    window.setTimeout(patchFindMyCoffeePage, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', run);
})();
